/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    'use strict';

    function executeJobAsync(datas) {
        // Execute request and reload page
        $.simAsync(
            {
                loader: false,
                baseUrl: '/servlet/com.jsbsoft.jtf.core.SG',
                baseParams: datas
            });
    }

    $(window).load(
        function () {
            window.jobsParams = ($('input[type=hidden][name=JOBS_PARAMS_JSON_OUT]').val() !== undefined && $('input[type=hidden][name=JOBS_PARAMS_JSON_OUT]').val() !== 'null' ? JSON.parse($('<div/>').html($('input[type=hidden][name=JOBS_PARAMS_JSON_OUT]').val()).text()) : {});
            window.isParamFormValid = function ($iframeContents) {
                var r = true;
                $iframeContents.each(
                    function () {
                        if (!$(this).val()) {
                            r = false;
                        }
                    });
                return r;
            };
            if ($('#scripts-automatises').length) {
                $('#scripts-automatises').on(
                    'click', ' a[data-key]', function (e) {
                        e.preventDefault();
                        var $t = $(this),
                            job = $t.attr('data-manual-launch');
                        var syncDatas = {
                            'PROC': 'SCRIPTS_AUTOMATISES',
                            'ACTION': 'EXECUTER',
                            'JOB': $t.data('key')
                        };
                        if (job) {
                            var configureDialog = $.iframePopin(
                                {
                                    title: LOCALE_BO.supervision.settings.title,
                                    url: '/servlet/com.jsbsoft.jtf.core.SG?PROC=SCRIPTS_AUTOMATISES&ACTION=PARAMETRAGE&JOB=' + job,
                                    buttons: {
                                        submit: {
                                            title: LOCALE_BO.valider,
                                            callback: function (iframe) {
                                                var datas = iframe.find('[data-field]');
                                                if (!isParamFormValid(datas)) {
                                                    return;
                                                }
                                                var fields = {};
                                                datas.each(
                                                    function (i) {
                                                        var $d = $(this);
                                                        fields[$d.attr('data-field')] = $d.val();
                                                    });
                                                window.jobsParams[job] = fields;
                                                this.close();
                                                syncDatas.PARAMS = JSON.stringify(window.jobsParams[job]);
                                                executeJobAsync(syncDatas);
                                            }
                                        },
                                        cancel: {
                                            title: LOCALE_BO.annuler,
                                            callback: function () {
                                                this.close();
                                            }
                                        }
                                    },
                                    onClose: function () {
                                        this.destroy();
                                    }
                                });
                            configureDialog.open();
                        } else {
                            executeJobAsync(syncDatas);
                        }
                        return false;
                    });
            }
            if ($('input[type=hidden][name=JOBS_PARAMS_JSON_OUT]').length > 0) { // Exécuter sur les pages correspondantes
                window.specificAfterItemAdd = function (list, items) {
                    $.each(
                        items, function (index, item) {
                            var regexpValue = new RegExp("([^,]*),(.*)");
                            var $item = $(item),
                                job = $item.data('value'),
                                params = $item.data('params'),
                                jobValues = regexpValue.exec(job);
                            var url = '/servlet/com.jsbsoft.jtf.core.SG?PROC=SCRIPTS_AUTOMATISES&ACTION=PARAMETRAGE&JOB=' + job;
                            if (jobValues && jobValues[1] && jobValues[2]) {
                                url = '/servlet/com.jsbsoft.jtf.core.SG?PROC=SCRIPTS_AUTOMATISES&ACTION=PARAMETRAGE&JOB=' + jobValues[1] + '&PARAMS=' + encodeURI(jobValues[2]);
                            }
                            if ($item.data('params')) {
                                var configureDialog = $.iframePopin(
                                    {
                                        title: LOCALE_BO.supervision.settings.title,
                                        url: url,
                                        buttons: {
                                            submit: {
                                                title: LOCALE_BO.valider,
                                                callback: function (iframe) {
                                                    if (updateParameter(iframe, $item)) {
                                                        this.close();
                                                    }
                                                }
                                            },
                                            cancel: {
                                                title: LOCALE_BO.annuler,
                                                callback: function () {
                                                    $('#kprocessbuilderJOBS').kProcessBuilder().remove('li[data-value="' + job + '"]');
                                                    this.close();
                                                }
                                            }
                                        },
                                        onClose: function () {
                                            $('#kprocessbuilderJOBS').kProcessBuilder().remove('li[data-value="' + job + '"]');
                                            this.destroy();
                                        }
                                    });
                                configureDialog.open();
                            } else {
                                if (!$item.attr('data-value').endsWith(', {}')) {
                                    $item.attr('data-value', $item.attr('data-value') + ', {}');
                                }
                                if (!$('input[name="JOBS"]').val().endsWith(', {}')) {
                                    $('input[name="JOBS"]').val($('input[name="JOBS"]').val() + ', {}');
                                }
                            }
                        });
                };
                window.specificEditAction = function (items) {
                    var regexpValue = new RegExp("([^,]*),(.*)");
                    $.each(items, function (index, item) {
                        var $item = $(item),
                            dataValue = $item.attr('data-value'),
                            values = regexpValue.exec(dataValue),
                            job = values[1],
                            params = values[2].replace(/\'/g, '"');
                        var configureDialog = $.iframePopin(
                            {
                                title: LOCALE_BO.supervision.settings.title,
                                url: '/servlet/com.jsbsoft.jtf.core.SG?PROC=SCRIPTS_AUTOMATISES&ACTION=PARAMETRAGE&JOB=' + job + '&PARAMS=' + encodeURI(params),
                                buttons: {
                                    submit: {
                                        title: LOCALE_BO.valider,
                                        callback: function (iframe) {
                                            if (updateParameter(iframe, $item)) {
                                                this.close();
                                            }
                                        }
                                    },
                                    cancel: {
                                        title: LOCALE_BO.annuler,
                                        callback: function () {
                                            this.close();
                                        }
                                    }
                                },
                                onClose: function () {
                                    this.destroy();
                                }
                            });
                        configureDialog.open();
                    });
                };
            }
        });

    /**
     * Actualise la valeur du champ caché "JOBS" suite au manipulation de l'utilisateur sur les scripts automatisés.
     * La maj est essentielle pour transmettre les bon paramètres lors de l'envoi au serveur.
     * @param iframe
     * @param $item
     */
    function updateParameter(iframe, $item) {
        var datas = iframe.find('[data-field]');
        if (!isParamFormValid(datas)) {
            return false;
        }
        var fields = {};
        datas.each(
            function getDataField() {
                var $d = $(this);
                fields[$d.attr('data-field')] = $d.val();
            });
        var itemValue = $item.data('value').split(',');
        $item.attr('data-value', itemValue[0] + ',' + JSON.stringify(fields));
        var values = $.cleanArray($('input[name="JOBS"]').val().split(';'));
        values[$item.index()] = $item.attr('data-value');
        $('input[name="JOBS"]').val(values.join(';'));
        return true;
    }
})(jQuery.noConflict());
